import { useQuery } from "@tanstack/react-query";
import adminApiClient, { KlydoFeedStats } from "../../api/admin";

const useKlydoFeedStats = (days: number, enabled: boolean) => {
  return useQuery<KlydoFeedStats>({
    queryKey: ["klydoFeedStats", days],
    queryFn: () => adminApiClient.getKlydoFeedStats(days),
    enabled,
  });
};

export default useKlydoFeedStats;
